import { pharmacyClient } from "@/connect";
import { SaleStatus } from "@/gen/sales/common_pb";

export const getSalesHistory = async (
  page: number,
  pageSize: number,
  userID?: number,
  startDate?: number,
  endDate?: number,
  type?: string
) => {
  let finalType = SaleStatus.UNSPECIFIED;

  if (type && type !== "") {
    switch (type) {
      case "COMPLETED":
        finalType = SaleStatus.COMPLETED;
        break;
      case "PARTIALLY_REFUNDED":
        finalType = SaleStatus.PARTIALLY_REFUNDED;
        break;
      case "FULLY_REFUNDED":
        finalType = SaleStatus.FULLY_REFUNDED;
        break;
      case "VOID":
        finalType = SaleStatus.VOIDED;
        break;
      case "ON_HOLD":
        finalType = SaleStatus.ON_HOLD;
        break;
      default:
        finalType = SaleStatus.UNSPECIFIED;
    }
  }

  const response_data = await pharmacyClient.listSales({
    page: page,
    pageSize: pageSize,
    createdBy: userID,
    startDate: startDate,
    endDate: endDate,
    status: finalType,
  });
  
  return {
    sales_history: response_data,
    users: response_data.users,
  };
};